import axios from 'axios';
import Promise from "lodash/_Promise";

export default {
    finances (query) {
        return axios
            .get('/api/finances', {
                params: {
                    per_page: query.perPage,
                    current_page: query.currentPage,
                    page: query.page,
                    search: query.search
                }
            })
            .catch(error => {
                return error.response;
            });
    },
    balances (query) {
        return axios
            .get('/api/finances/balances', {
                params: {
                    per_page: query.perPage,
                    current_page: query.currentPage,
                    page: query.page,
                    search: query.search
                }
            })
            .catch(error => {
                return error.response;
            });
    },
    exportBalances (query) {
        return axios
            .get('/api/finances/balances/export', {
                responseType: 'blob',
                params: {
                    search: query.search
                }
            })
            .then(function (response) {
                return response;
            });
    },
    statuses() {
        return axios.get("/api/finances/statuses");
    },
    updateStatuses(data) {
        return axios.post("/api/finances/statuses/update", data);
    },
    deleteStatus(data) {
        return axios.post("/api/finances/statuses/delete", data);
    },
    saveFinanceStatus (data) {
        return axios
            .post('/api/candidate/finance/status', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },

    tasksTypes() {
        return axios.get("/api/finances/task_types");
    },
    updateTaskTypes(data) {
        return axios.post("/api/finances/task_types/update", data);
    },
    deleteTaskType(data) {
        return axios.post("/api/finances/task_types/delete", data);
    },
    saveTask (data) {
        return axios
            .post('/api/candidate/finance/status', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },

    showUser (id) {
        return axios.get('/api/candidate/' + id);
    },
    creditTypes() {
        return axios.get("/api/finances/credit_types");
    },

    financesType (query) {
        return axios
            .get('/api/finances/' + query.type, {
                params: {
                    per_page: query.perPage,
                    current_page: query.currentPage,
                    page: query.page,
                    search: query.search
                }
            })
            .catch(error => {
                return error.response;
            });
    },
    financesCheckStatus (query) {
        return axios
            .get('/api/finances/checks', {
                params: {
                    per_page: query.perPage,
                    current_page: query.currentPage,
                    page: query.page,
                    search: query.search
                }
            })
            .catch(error => {
                return error.response;
            });
    },
    financesCashFlowAmount (query) {
        return axios
            .get('/api/finances/cashflow/amount', {
                params: {
                    search: query.search
                }
            })
            .catch(error => {
                return error.response;
            });
    },
    financesCashFlow (query) {
        return axios
            .get('/api/finances/cashflow', {
                params: {
                    per_page: query.perPage,
                    current_page: query.currentPage,
                    page: query.page,
                    search: query.search
                }
            })
            .catch(error => {
                return error.response;
            });
    },
    financesTotalCashFlow (query) {
        return axios
            .get('/api/finances/paiements/cashflow', {
                params: {
                    per_page: query.perPage,
                    current_page: query.currentPage,
                    page: query.page,
                    search: query.search
                }
            })
            .catch(error => {
                return error.response;
            });
    },
    exportCheckStatus (query) {
        return axios
            .get('/api/finances/checks/export', {
                responseType: 'blob',
                params: {
                    type: query.type,
                    search: query.search
                }
            })
            .then(function (response) {
                return response;
            });
    },
    exportCashFlow (query) {
        return axios
            .get('/api/finances/cashflow/export', {
                responseType: 'blob',
                params: {
                    type: query.type,
                    search: query.search
                }
            })
            .then(function (response) {
                return response;
            });
    },
    exportCashFlowPaiements(query) {
        return axios
            .get('/api/finances/paiements/cashflow/export', {
                responseType: 'blob',
                params: {
                    type: query.type,
                    search: query.search
                }
            })
            .then(function (response) {
                return response;
            });
    },
    exportApplications (query) {
        return axios
            .get('/api/finances/export', {
                responseType: 'blob',
                params: {
                    search: query.search
                }
            })
            .then(function (response) {
                return response;
            });
    },
    getContactFinance (contactId) {
        return axios
            .get('/api/candidate/finance/' + contactId)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    updatePayment (data) {
        return axios
            .post('/api/candidate/finances/update', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    deletePayment (data) {
        return axios
            .post('/api/candidate/finances/delete', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    addPayment (data) {
        return axios
            .post('/api/candidate/finances/add', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    applicationAccountingReviewed (data) {
        return axios
            .post('/api/candidate/finances/application_accounting_reviewed', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    orderAccountingReviewed (data) {
        return axios
            .post('/api/candidate/finances/order_accounting_reviewed', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    updateBilling (data) {
        return axios
            .post('/api/candidate/finances/updateBilling', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    deleteBilling (data) {
        return axios
            .post('/api/candidate/finances/deleteBilling', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    addCredit (data) {
        return axios
            .post('/api/candidate/finances/credit/add', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    updateCredit (data) {
        return axios
            .post('/api/candidate/finances/credit/update', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    deleteCredit (data) {
        return axios
            .post('/api/candidate/finances/credit/delete', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    addPromo (data) {
        return axios
            .post('/api/candidate/finances/promo/add', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    applyPromoCode(data) {
        return axios
            .post('/api/offers/promo-code/apply', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    removePromoCode(data) {
        return axios
            .post('/api/offers/promo-code/remove', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    setApplicationPromo (data) {
        return axios
            .post('/api/candidate/application/promo/set', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    removeApplicationPromo (data) {
        return axios
            .post('/api/candidate/application/promo/remove', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    setOrderPromo (data) {
        return axios
            .post('/api/candidate/order/promo/set', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    removeOrderPromo (data) {
        return axios
            .post('/api/candidate/order/promo/remove', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    updatePromo (data) {
        return axios
            .post('/api/candidate/finances/promo/update', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    deletePromo (data) {
        return axios
            .post('/api/candidate/finances/promo/delete', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    switchPaymentLocation (data) {
        return axios
            .post('/api/candidate/finances/switchLocation', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    updateReport (data) {
        return axios
            .post('/api/candidate/finances/report/update', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    addReport (data) {
        return axios
            .post('/api/candidate/finances/report/add', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    deleteReport (data) {
        return axios
            .post('/api/candidate/finances/report/delete', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    exportPayments (query) {
        return axios
            .get('/api/finances/' + query.type + '/export', {
                responseType: 'blob',
                params: {
                    type: query.type,
                    search: query.search
                }
            })
            .then(function (response) {
                return response;
            });
    },
    importCredits(file) {
        return axios
            .post('/api/fimances/credit/import', file)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    importPromos(file) {
        return axios
            .post('/api/fimances/promo/import', file)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
};
